var _itemTypeToComponent;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import BsPagination from 'react-bootstrap/es/Pagination';
import { createUltimatePagination, ITEM_TYPES } from 'react-ultimate-pagination';
import LeftPaginationArrow from "../../icon-components/left-pagination-arrow";
import RightPaginationArrow from "../../icon-components/right-pagination-arrow";
import ThreeDots from "../../icon-components/three-dots/three-dots";
var leftArrow = React.createElement(LeftPaginationArrow, null);
var rightArrow = React.createElement(RightPaginationArrow, null);
var CLASSNAME = 'frc-pagination';

var WrapperComponent = function WrapperComponent(props) {
  return React.createElement("div", {
    className: CLASSNAME
  }, React.createElement(BsPagination, props));
};
/* eslint-disable react/prop-types */


var UltimatePagination = createUltimatePagination({
  WrapperComponent: WrapperComponent,
  itemTypeToComponent: (_itemTypeToComponent = {}, _defineProperty(_itemTypeToComponent, ITEM_TYPES.PAGE, function (_ref) {
    var value = _ref.value,
        isActive = _ref.isActive,
        onClick = _ref.onClick;
    return React.createElement(BsPagination.Item, {
      active: isActive,
      onClick: onClick
    }, value);
  }), _defineProperty(_itemTypeToComponent, ITEM_TYPES.ELLIPSIS, function (_ref2) {
    var isActive = _ref2.isActive,
        onClick = _ref2.onClick;
    return React.createElement(BsPagination.Ellipsis, {
      disabled: isActive,
      onClick: onClick
    }, React.createElement(ThreeDots, {
      className: "".concat(CLASSNAME, "-ellipsis")
    }));
  }), _defineProperty(_itemTypeToComponent, ITEM_TYPES.FIRST_PAGE_LINK, function (_ref3) {
    var onClick = _ref3.onClick;
    return React.createElement(BsPagination.First, {
      onClick: onClick
    }, leftArrow);
  }), _defineProperty(_itemTypeToComponent, ITEM_TYPES.LAST_PAGE_LINK, function (_ref4) {
    var onClick = _ref4.onClick;
    return React.createElement(BsPagination.First, {
      onClick: onClick
    }, rightArrow);
  }), _itemTypeToComponent)
});
/* eslint-enable react/prop-types */

/**
 * The pagination component, it internally uses [React Ultimate Pagination](https://www.npmjs.com/package/react-ultimate-pagination)
 * and wraps [React Bootstrap's Pagination](https://react-bootstrap.github.io/components/pagination/)
 *
 * @see [React Ultimate Pagination](https://www.npmjs.com/package/react-ultimate-pagination)
 */

var Pagination = function Pagination(props) {
  return React.createElement(UltimatePagination, _extends({
    hidePreviousAndNextPageLinks: true
  }, props));
};

Pagination.propTypes = {
  /**
   * Total number of pages
   */
  totalPages: PropTypes.number.isRequired,

  /**
   * Current page number
   */
  currentPage: PropTypes.number.isRequired,

  /**
   * Hide ellipsis buttons
   */
  hideEllipsis: PropTypes.bool,

  /**
   * Callback that will be called with new page when it should be changed by user interaction
   */
  onChange: PropTypes.func,

  /**
   * Disable all the buttons in the pagination
   */
  disabled: PropTypes.bool
};
Pagination.defaultProps = {
  hideEllipsis: false,
  disabled: false
};
Pagination.displayName = 'Pagination';
export default Pagination;